import {CheckIcon} from '@primer/octicons-react'
import styles from './ResolvedPlanStatus.module.css'

/** Simple status line shown when a plan has been approved */
export function ResolvedPlanStatus() {
  return (
    <span className={styles.container}>
      <CheckIcon size={16} />
      Plan approved
    </span>
  )
}
